import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { toArray } from '@sportninja/common/utils/utils'
import { getSports } from '@sportninja/common/selectors/types'
import { t } from '@sportninja/common/i18n'

import { SelectFormInput } from '../Select'

const PositionSelect = ({ sportName = 'hockey', sports, ...selectFormProps }) => {
  const sportPositions = sports && sports.find((s) => s.name === sportName)
  const positions = sportPositions && sportPositions.players.filter((playerType) => {
    return !['coach', 'team official'].includes(playerType?.name_full?.toLowerCase())
  })?.reverse()

  return (
    <SelectFormInput {...selectFormProps}>
      <option value='' disabled>{t('Web:selectAPosition')}:</option>
      <option disabled>-----</option>
      {positions && positions.map((p) => {
        return <option key={p.id} value={p.id}>{p.name_full}</option>
      })}
    </SelectFormInput>
  )
}

PositionSelect.propTypes = {
  sportName: PropTypes.string,
  sports: PropTypes.array.isRequired
}

const mapStateToProps = (state) => {
  return {
    sports: toArray(getSports(state))
  }
}

export default connect(mapStateToProps)(PositionSelect)

